<template>
  <div class="header">
    <div class="header-container">
      <div class="header-left">
        <img
          class="logo"
          src="../assets/images/logo.png"
          alt=""
          @click="fetchActivityStatus"
        />
        <div class="social-list">
          <a
            class="social-item"
            v-for="(item, index) in socialList"
            :key="index"
            :href="item.url"
          >
            <div class="img-bg" :class="['social-item-' + (index + 1)]"></div>
          </a>
        </div>
      </div>
      <div class="header-right">
        <div class="connect-wallet" @click="connectWallet(true)">
          {{ walletText }}
        </div>
        <div
          class="language-content"
          @mouseenter="onMouseEnter"
          @mouseleave="onMouseLeave"
        >
          <template v-if="isEnter">
            <img
              v-if="$i18n.locale === 'en'"
              class="language-icon"
              src="../assets/images/en-on.png"
              alt=""
            />
            <img
              class="language-icon"
              v-else
              src="../assets/images/zh-on.png"
              alt=""
            />
          </template>
          <template v-else>
            <img
              v-if="$i18n.locale === 'en'"
              class="language-icon"
              src="../assets/images/en.png"
              alt=""
            />
            <img
              class="language-icon"
              v-else
              src="../assets/images/zh.png"
              alt=""
            />
          </template>
          <div class="menu-icon" @click="openMenu">
            <img src="../assets/images/menu.png" alt="" />
          </div>
          <div class="language-list-wrap">
            <div class="language-list">
              <div
                class="language-item"
                v-for="(item, index) in languageList"
                :key="index"
                @mouseenter="onLanguageEnter(item)"
                @mouseleave="onLanguageLeave(item)"
                @click="changeLang(item.lang)"
              >
                <div class="language-wrap">
                  <img v-if="item.isEnter" :src="item.languageImgOn" alt="" />
                  <img v-else :src="item.languageImg" alt="" />
                  <div class="language-label">{{ item.label }}</div>
                </div>
                <img
                  v-if="$i18n.locale === item.lang"
                  class="selected"
                  src="../assets/images/selected.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <MenuMobile v-if="isMenuMobile" @close="closeMenuMobile" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tp from 'tp-js-sdk';
import MenuMobile from './MenuMobile.vue';

export default {
  components: { MenuMobile },
  data() {
    return {
      isMenuMobile: false,
      isEnter: false,
      languageList: [
        {
          lang: 'zh',
          label: '中文（简体）',
          languageImg: require('../assets/images/zh.png'),
          languageImgOn: require('../assets/images/zh-on.png'),
          isEnter: false,
        },
        {
          lang: 'zh-tw',
          label: '中文（繁体）',
          languageImg: require('../assets/images/zh.png'),
          languageImgOn: require('../assets/images/zh-on.png'),
          isEnter: false,
        },
        {
          lang: 'en',
          label: 'English',
          languageImg: require('../assets/images/en.png'),
          languageImgOn: require('../assets/images/en-on.png'),
          isEnter: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['address', 'isTp']),
    walletText() {
      if (this.address) {
        return this.address.slice(0, 5) + '...' + this.address.slice(-5);
      } else {
        return this.$t('connectWallet');
      }
    },
    socialList() {
      return [
        {
          icon: require(`../assets/images/social/1.png`),
          url: 'https://tokenpocket.pro/',
        },
        {
          icon: require(`../assets/images/social/2.png`),
          url: 'https://twitter.com/TokenPocket_TP',
        },
        {
          icon: require(`../assets/images/social/3.png`),
          url: 'https://t.me/tokenpocket_channel',
        },
      ];
    },
  },
  mounted() {
    if (window.tokenpocket && window.ethereum.isTokenPocket) {
      this.connectWallet()
    }
  },
  methods: {
    openMenu() {
      this.isMenuMobile = !this.isMenuMobile;
    },
    closeMenuMobile() {
      this.isMenuMobile = false;
      document.body.style.overflow = 'auto';
    },
    onMouseEnter() {
      this.isEnter = true;
    },
    onMouseLeave() {
      this.isEnter = false;
    },
    onLanguageEnter(item) {
      item.isEnter = true;
    },
    onLanguageLeave(item) {
      item.isEnter = false;
    },
    async fetchActivityStatus() {
      const graphqlEndpoint = 'https://graphigo.prd.galaxy.eco/query';
      // GraphQL查询
      const graphqlQuery = `
        {
          campaign(id: "GCE2JUUkft") {
            userParticipants(
              address: "0x74f85Fe5538DbfCF3B46399E121c3bA83F695f91"
              first: 10
            ) {
              totalCount
            }
            participationStatus(
              address: "0x74f85Fe5538DbfCF3B46399E121c3bA83F695f91"
            )
          }
        }
      `;

      // 使用fetch发送GraphQL请求
      fetch(graphqlEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // 添加其他标头，例如身份验证标头，如果需要的话
        },
        body: JSON.stringify({
          query: graphqlQuery,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // 处理GraphQL响应数据
          console.log(data);
        })
        .catch((error) => {
          console.error('GraphQL请求失败', error);
        });
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
    },
    async connectWallet(flag) {
      if (this.isTp) {
        if (window.ethereum) {
          let account = await this.getAccount()
          this.$store.commit('setAddress', account[0]);
          if (window.ethereum.chainId === '0x1b59') {
            this.$store.commit('setStep', 3);
          } else {
            this.$store.commit('setStep', 2);
            this.$emit('loginTP');
          }
          if (flag) {
            this.$emit('loginTP');
          }
        }
      } else {
        // console.log('ethereum', window.ethereum);
        if (window.tokenpocket && window.ethereum.isTokenPocket) {
          let account = await this.getAccount()
          this.$store.commit('setAddress', account[0]);
          this.$store.commit('setStep', 2);
        } else {
          // console.log('请先下载');
          this.$emit('walletModal', true);
        }
      }
    },
    async getAccount() {
      let account = await window.ethereum.request({
        method: 'eth_accounts',
      });
      // console.log('account', account);
      if (!account.length) {
        account = await window.ethereum.request({
          method: 'eth_requestAccounts',
        });
      }
      return account
    }
  },
};
</script>

<style lang="scss" scoped>
@for $i from 1 through 3 {
  .social-item-#{$i} {
    background: url(../assets/images/social/#{$i}.png) no-repeat 100% / contain;
    cursor: pointer;
    &:hover {
      background: url(../assets/images/social/#{$i}-on.png)
        no-repeat
        100% /
        contain;
    }
  }
}
.header {
  width: 100%;
  padding: 0.2rem 0;
  .header-container {
    max-width: 12rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-left {
      display: flex;
      align-items: center;
      .logo {
        width: 1.96rem;
        height: 0.28rem;
      }
      .social-list {
        margin-left: 0.23rem;
        display: flex;
        align-items: center;
        .social-item {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.05rem;
          border: 0.01rem solid #e3e3e3;
          border-radius: 0.08rem;
          cursor: pointer;
          &:nth-child(n + 2) {
            margin-left: 0.12rem;
          }
          .img-bg {
            width: 0.18rem;
            height: 0.18rem;
          }
        }
        .social-item:hover {
          background: #deebff;
          border: 0.01rem solid #2980fe;
        }
      }
    }
    .header-right {
      display: flex;
      align-items: stretch;
      .connect-wallet {
        padding: 0.08rem 0.16rem;
        background: #2980fe;
        border-radius: 0.18rem;
        font-size: 0.13rem;
        font-family: Poppins-Bold;
        color: #ffffff;
        cursor: pointer;
      }
      .language-content {
        position: relative;
        padding-left: 0.22rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .language-icon {
          width: 0.2rem;
          height: 0.2rem;
        }
        .menu-icon {
          display: none;
        }
        .language-list-wrap {
          display: none;
          position: absolute;
          z-index: 99;
          top: 0.36rem;
          right: 0;
          padding-top: 0.06rem;
          .language-list {
            background: #ffffff;
            border: 0.01rem solid #f7f7f7;
            border-radius: 0.11rem;
            box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.2);
            padding: 0.12rem;
            .language-item {
              display: flex;
              justify-content: space-between;
              padding: 0.12rem;
              &:nth-child(n + 2) {
                margin-top: 0.08rem;
              }
              .language-wrap {
                display: flex;
                align-items: center;
                min-width: 1.1rem;
                img {
                  width: 0.2rem;
                  height: 0.2rem;
                }
                .language-label {
                  margin-left: 0.08rem;
                  font-size: 0.13rem;
                  font-family: Poppins-Medium;
                  text-align: left;
                  white-space: nowrap;
                }
              }
              .selected {
                margin-left: 0.18rem;
                width: 0.16rem;
                height: 0.16rem;
              }
            }
            .language-item:hover {
              background: #f5f5f5;
              border-radius: 0.12rem;
              .language-wrap {
                .language-label {
                  color: #2980fe;
                }
              }
            }
          }
        }
      }
      .language-content:hover {
        .language-list-wrap {
          display: block;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .header {
    padding: 0.4rem 0.32rem;
    .header-container {
      .header-left {
        .logo {
          width: 2.74rem;
          height: 0.4rem;
        }
        .social-list {
          display: none;
        }
      }
      .header-right {
        .connect-wallet {
          font-size: 0.26rem;
          padding: 0.1rem 0.32rem;
          border-radius: 0.5rem;
        }
        .language-content {
          // margin-left: 15px;
          .language-icon {
            display: none;
            width: 0.4rem;
            height: 0.4rem;
          }
          .menu-icon {
            display: flex;
            img {
              width: 0.32rem;
              height: 0.32rem;
            }
          }
          .language-list-wrap {
            top: 0.6rem;
          }
        }
        .language-content:hover {
          .language-list-wrap {
            display: none;
          }
        }
      }
    }
  }
}
</style>
